import { AuthModel } from '../auth-model'
import { createSelector } from '@ngrx/store'

export interface PermissionGrantedArgs {
  permission: number
}

export interface AnyPermissionGrantedArgs {
  permissions: number[]
}

export interface AuthSelectors<TAppState> {
  selectIsAuthenticated: (state: TAppState) => boolean
  selectUserPermissions: (state: TAppState) => number[]
  selectUserFeatures: (state: TAppState) => number[]
  selectUserName: (state: TAppState) => string
  selectUserId: (state: TAppState) => string
  selectUserRoles: (state: TAppState) => string[]
}

export function getAuthSelectors<TAppState>(
  featureSelector: (state: TAppState) => AuthModel
): AuthSelectors<TAppState> {
  const selectIsAuthenticated = createSelector(featureSelector, state => state.isAuthenticated)

  const selectUserPermissions = createSelector(featureSelector, state =>
    state.user ? state.user.Permissions : []
  )
  const selectUserFeatures = createSelector(featureSelector, state =>
    state.user ? state.user.Features : []
  )

  const selectUserName = createSelector(featureSelector, state =>
    state.user ? state.user.FirstName + ' ' + state.user.LastName : ''
  )

  const selectUserId = createSelector(featureSelector, state => (state.user ? state.user.Id : ''))

  const selectUserRoles = createSelector(featureSelector, state =>
    state.user ? state.user.Roles : []
  )

  return {
    selectIsAuthenticated,
    selectUserPermissions,
    selectUserFeatures,
    selectUserName,
    selectUserId,
    selectUserRoles
  }
}
